module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/173-mali-0a1b91ce8a39937237c210570a23d581.svg";